import { render, staticRenderFns } from "./Liana.vue?vue&type=template&id=23a583e4&scoped=true"
import script from "./Liana.vue?vue&type=script&lang=js"
export * from "./Liana.vue?vue&type=script&lang=js"
import style0 from "./Liana.vue?vue&type=style&index=0&id=23a583e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a583e4",
  null
  
)

export default component.exports